import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlans = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.5 2.3125C10.6046 2.3125 11.5 3.20793 11.5 4.3125V11.6875C11.5 12.7232 10.7128 13.5745 9.7041 13.6768L9.5 13.6875H6.5L6.2959 13.6768C5.35435 13.5813 4.6062 12.8332 4.51074 11.8916L4.5 11.6875V4.3125C4.5 3.20793 5.39543 2.3125 6.5 2.3125H9.5ZM6.5 3.3125C5.94772 3.3125 5.5 3.76022 5.5 4.3125V11.6875C5.5 12.2398 5.94772 12.6875 6.5 12.6875H9.5C10.0523 12.6875 10.5 12.2398 10.5 11.6875V4.3125C10.5 3.76022 10.0523 3.3125 9.5 3.3125H6.5ZM3.625 4.625H3C2.44772 4.625 2 5.07272 2 5.625V10.375C2 10.9273 2.44772 11.375 3 11.375H3.625V12.375H3L2.7959 12.3643C1.85435 12.2688 1.1062 11.5207 1.01074 10.5791L1 10.375V5.625C1 4.52043 1.89543 3.625 3 3.625H3.625V4.625ZM13 3.625C14.1046 3.625 15 4.52043 15 5.625V10.375L14.9893 10.5791C14.8938 11.5207 14.1457 12.2688 13.2041 12.3643L13 12.375H12.375V11.375H13C13.5523 11.375 14 10.9273 14 10.375V5.625C14 5.07272 13.5523 4.625 13 4.625H12.375V3.625H13Z",
		fill: "currentColor"
	})
});
export default SvgPlans;
